module.exports = __webpack_public_path__ + "img/露沟.8aa5177a.jpg";